'use client';

import { PaletteMode } from '@mui/material';
import { createContext } from 'react';

export const ColorModeContext = createContext<{
  toggleColorMode: () => void;
  setColorMode: (mode: PaletteMode) => void;
  mode: PaletteMode;
}>({
  toggleColorMode: () => {},
  // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
  setColorMode: (mode: PaletteMode) => {},
  mode: 'dark',
});
